
<template>
  <v-application>
    <v-settings :loading_data="loading_workgroup">
      <v-toolbar flat class="pt-2">
        <v-toolbar-title>{{ $t("workgroup") }}</v-toolbar-title>
        <v-spacer />
        <v-btn v-if="disabled" @click="disabled = false" icon>
          <v-icon color="primary">mdi-pencil</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form v-model="is_valid">
        <v-card-text>
          <draggable
            :list="workgroups"
            tag="v-list"
            handle=".v-list-item__icon"
          >
            <v-list-item
              :disabled="disabled"
              v-for="(item, index) in workgroups"
              v-bind:key="index"
              v-model="item.value"
            >
              <v-list-item-icon v-if="!disabled" style="margin-right: 10px">
                <v-icon>mdi-menu</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-text-field
                  hide-details
                  outlined
                  dense
                  v-model="item.name"
                  :ref="'name_' + index"
                  :rules="[fieldRules.required]"
                />
              </v-list-item-content>
              <v-list-item-icon
                v-if="!disabled && is_editable"
                style="margin-left: 10px"
              >
                <v-btn icon @click="getCurrentWorkgroup(item)">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </v-list-item-icon>
              <v-list-item-icon v-if="!disabled && !drawer">
                <v-btn icon @click="remove_ticket(index)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </draggable>
          <v-btn
            v-if="!disabled"
            :disabled="loading_workgroup || drawer"
            text
            color="primary"
            small
            v-on:click="add_workgroups"
          >
            <v-icon>mdi-plus</v-icon>
            {{ $t("add_workgroup") }}
          </v-btn>
        </v-card-text>
      </v-form>
      <template #actions>
        <v-btn
          v-if="!disabled && !drawer"
          :disabled="loading_workgroup"
          text
          v-on:click="cancelClicked"
          >{{$t('cancel')}}</v-btn
        >
        <v-btn
          v-if="!disabled && !drawer"
          :disabled="loading_workgroup || saveDisabled"
          text
          color="primary"
          v-on:click="saveClicked"
          >{{ $t("save") }}</v-btn
        >
      </template>
    </v-settings>

    <v-navigation-drawer
      v-model="drawer"
      right
      absolute
      :width="drawer ? 600 : 0"
    >
      <v-progress-linear
        v-if="loading_current_workgroup"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-layout row px-4 py-2>
        <v-spacer />
        <v-hover v-slot:default="{ hover }">
          <v-btn icon @click="drawer = false">
            <v-icon :class="hover ? 'black--text rotate90' : 'grey--text'"
              >mdi-close</v-icon
            >
          </v-btn>
        </v-hover>
      </v-layout>
      <div v-if="create_task == false">
        <v-layout row px-2>
          <v-flex px-2 mx-2 md12 class="text-center">
            <p class="font-weight-bold body-2">{{ $t(`workgroup`) }}</p>
          </v-flex>
        </v-layout>
        <hr class="mx-2" style="border: 0.5px dashed grey" />

        <v-layout row px-2 mx-2>
          <v-flex px-2>
            <v-text-field
              v-model="current_workgroup.name"
              :label="$t('name')"
              ref="group_name"
              :rules="[fieldRules.required]"
            />
          </v-flex>
        </v-layout>
        <v-layout row px-2 mx-2>
          <v-flex px-2>
            <v-autocomplete
              v-model="current_workgroup.task_id"
              :items="all_tasks"
              item-text="title"
              item-value="_id"
              :label="$t('task')"
              :no-data-text="'No task'"
              ref="task"
              :rules="[fieldRules.required]"
            />
          </v-flex>
        </v-layout>
        <v-layout row px-2 mx-2>
          <v-flex px-2>
            <v-checkbox v-model="current_workgroup.is_warehouse" :label="$t('warehause')" @change="warehauseChanged"></v-checkbox>
          </v-flex>
        </v-layout>
        <v-layout row px-2 mx-2>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="create_task = true">{{
            $t("create_task")
          }}</v-btn>
          <v-btn
            color="primary"
            text
            :disabled="drawerSaveDisabled"
            @click="updateWorkgroup"
            >{{ $t("save") }}</v-btn
          >
        </v-layout>

        <v-divider></v-divider>
        <v-layout row px-2 mx-2 mt-5 style="font-weight: bold; color: #4baf4f">
          {{ $t("order_information") }}
          <v-spacer />
          <v-btn
            v-if="!edit_order_information"
            icon
            @click="edit_order_information = true"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-layout>

        <div>
          <v-form v-model="is_valid_order_information">
            <v-list-item
              class="ma-0 pa-0"
              v-for="(itm, ind) in order_informations"
              :key="ind"
            >
              <v-list-item-content class="ma-0 pa-0 px-4">
                <v-layout row>
                  <v-flex md6 px-2>
                    <v-text-field
                      v-model="order_informations[ind].text"
                      :rules="[fieldRules.required]"
                      :readonly="!edit_order_information"
                      :label="$t('text')"
                    />
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-autocomplete
                      v-model="order_informations[ind].workgroup"
                      :items="workgroups_without_current"
                      multiple
                      item-value="_id"
                      item-text="name"
                      :rules="[fieldRules.required]"
                      :readonly="!edit_order_information"
                      :label="$t('workgroups')"
                    />
                  </v-flex>
                </v-layout>
              </v-list-item-content>
              <v-list-item-icon v-if="edit_order_information">
                <v-btn icon @click="removeOrderInformation(ind)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-form>
          <v-layout v-if="edit_order_information" row px-2 mx-2>
            <v-btn
              :disabled="!is_valid_order_information"
              color="primary"
              text
              @click="addOrderInformation"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("add_order_information") }}
            </v-btn>
          </v-layout>
          <v-layout v-if="edit_order_information" row px-2 mx-2>
            <v-spacer />
            <v-btn text @click="cancelOrderInformation">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              :disabled="!is_valid_order_information || has_order_information"
              :loading="saving_order_information"
              @click="saveOrderInformation"
            >
              {{ $t("save") }}
            </v-btn>
          </v-layout>
        </div>

        <v-divider></v-divider>
        <v-layout row px-2 mx-2 mt-5 style="font-weight: bold; color: #4baf4f">
          {{ $t("device_information") }}
          <v-spacer />
          <v-btn
            v-if="!edit_device_information"
            icon
            @click="edit_device_information = true"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-layout>

        <div>
          <v-form v-model="is_valid_device_information">
            <v-list-item
              class="ma-0 pa-0"
              v-for="(itm, ind) in device_informations"
              :key="ind"
            >
              <v-list-item-content class="ma-0 pa-0 px-4">
                <v-layout row>
                  <v-flex md6 px-2>
                    <v-text-field
                      v-model="device_informations[ind].text"
                      :rules="[fieldRules.required]"
                      :readonly="!edit_device_information"
                      :label="$t('text')"
                    />
                  </v-flex>
                  <v-flex md6 px-2>
                    <v-autocomplete
                      v-model="device_informations[ind].workgroup"
                      :items="workgroups_without_current"
                      multiple
                      item-value="_id"
                      item-text="name"
                      :rules="[fieldRules.required]"
                      :readonly="!edit_device_information"
                      :label="$t('workgroups')"
                    />
                  </v-flex>
                </v-layout>
              </v-list-item-content>
              <v-list-item-icon v-if="edit_device_information">
                <v-btn icon @click="removeDeviceInformation(ind)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-form>

          <v-layout v-if="edit_device_information" row px-2 mx-2>
            <v-btn
              :disabled="!is_valid_device_information"
              color="primary"
              text
              @click="addDeviceInformation"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("add_device_information") }}
            </v-btn>
          </v-layout>
          <v-layout v-if="edit_device_information" row px-2 mx-2>
            <v-spacer />
            <v-btn text @click="cancelDeviceInformation">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              :disabled="!is_valid_device_information || has_device_information"
              :loading="saving_device_information"
              @click="saveDeviceInformation"
            >
              {{ $t("save") }}
            </v-btn>
          </v-layout>
        </div>

        <v-divider></v-divider>
        <v-layout row px-2 mx-2 mt-5 style="font-weight: bold; color: #4baf4f">
          {{ $t("additional_information") }}
          <v-spacer />
          <v-btn
            v-if="!edit_additional_information"
            icon
            @click="edit_additional_information = true"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </v-layout>
        <div>
          <v-form v-model="is_valid_additional_information">
            <v-list-item
              class="ma-0 pa-0"
              v-for="(itm, ind) in additional_informations"
              :key="ind"
            >
              <v-list-item-content class="ma-0 pa-0 px-4">
                <v-layout row>
                  <v-flex md12 px-2>
                    <v-text-field
                      v-model="additional_informations[ind].text"
                      :rules="[fieldRules.required]"
                      :readonly="!edit_additional_information"
                    />
                  </v-flex>
                </v-layout>
              </v-list-item-content>
              <v-list-item-icon v-if="edit_additional_information">
                <v-btn icon @click="removeAdditionalInformation(ind)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
          </v-form>

          <v-layout v-if="edit_additional_information" row px-2 mx-2>
            <v-btn
              :disabled="!is_valid_additional_information"
              color="primary"
              text
              @click="addAdditionalInformation"
            >
              <v-icon>mdi-plus</v-icon>
              {{ $t("add_additional_information") }}
            </v-btn>
          </v-layout>
          <v-layout v-if="edit_additional_information" row px-2 mx-2>
            <v-spacer />
            <v-btn text @click="cancelAdditionalInformation">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              text
              color="primary"
              :disabled="!is_valid_additional_information || has_additional_information"
              :loading="saving_additional_information"
              @click="saveAdditionalInformation"
            >
              {{ $t("save") }}
            </v-btn>
          </v-layout>
        </div>
      </div>
      <div v-else>
        <v-layout row px-2>
          <v-flex px-2 mx-2 md12 class="text-center">
            <p class="font-weight-bold body-2">{{ $t(`task`) }}</p>
          </v-flex>
        </v-layout>
        <hr class="mx-2" style="border: 0.5px dashed grey" />
        <v-layout row px-2 mx-2>
          <v-flex px-2>
            <v-text-field
              v-model="current_task.title"
              :label="$t('title')"
              ref="title"
              :rules="[fieldRules.required]"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row px-2 mx-2>
          <v-flex px-2>
            <v-radio-group
              v-model="current_task.unit_name"
              row
              :label="$t('unit_name')"
            >
              <v-radio label="m" value="m"></v-radio>
              <v-radio label="l" value="l"></v-radio>
              <v-radio label="kg" value="kg"></v-radio>
              <v-radio label="pkg" value="pkg"></v-radio>
              <v-radio label="box" value="box"></v-radio>
              <v-radio label="t" value="t"></v-radio>
              <v-radio label="qty" value="qty"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout
          row
          px-2
          mx-2
          v-for="(limit, index) in current_task.limits"
          :key="index"
        >
          <v-flex px-2 md6>
            <v-text-field
              v-model="limit.from"
              :label="$t('from')"
              type="number"
              :ref="'from_' + index"
              :rules="[fieldRules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex px-2 md6>
            <v-text-field
              v-model="limit.to"
              :label="$t('to')"
              type="number"
              :ref="'to_' + index"
              :rules="[fieldRules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex px-2 md12>
            <v-text-field
              v-model="limit.bonus"
              :label="$t('bonus')"
              type="number"
              :ref="'bonus_' + index"
              :rules="[fieldRules.required]"
            ></v-text-field>
          </v-flex>
          <v-flex px-2 md4>
            <v-radio-group
              v-model="limit.type"
              row
              :label="$t('type')"
              :ref="'type_' + index"
              :rules="[fieldRules.require]"
            >
              <v-radio :label="$t('a')" value="a" />
              <v-radio :label="$t('p')" value="p" />
            </v-radio-group>
          </v-flex>
          <v-flex px-2 md6>
            <v-checkbox
              v-model="limit.each"
              :label="$t('calculate_bonus_for_each')"
            />
          </v-flex>
          <v-flex px-2 mt-3 md2>
            <v-btn icon mt-4 @click="removeLimit(index)">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout row px-2 mx-2>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="current_task.limits.push({ type: 'a' })"
            >{{ $t("add_limit") }}</v-btn
          >
          <v-btn
            color="primary"
            text
            :disabled="taskSaveDisabled"
            @click="createTask"
            >{{ $t("save") }}</v-btn
          >
        </v-layout>
      </div>
    </v-navigation-drawer>
  </v-application>
</template>

<script>
import Workgroup from "../../mixins/employees/workgroup";
import WorkgroupInfo from "../../mixins/employees/workgroup_info";

export default {
  name: "Workgroup",
  data: () => ({
    disabled: true,
    create_task: false,
    loading_workgroup: false,
    drawer: false,
    loading_current_workgroup: false,
    current_workgroup: {
      name: null,
      task_id: null,
    },
    all_tasks: [],
    current_task: {
      title: null,
      type: "meal",
      unit_name: "kg",
      limits: [
        {
          from: "0",
          to: 10,
          bonus: "0",
          type: "a",
        },
      ],
    },
    is_valid: false,
    edit_order_information: false,
    edit_device_information: false,
    edit_additional_information: false,
    is_valid_order_information: false,
    is_valid_device_information: false,
    is_valid_additional_information: false,
    saving_order_information: false,
    saving_device_information: false,
    saving_additional_information: false
  }),
  computed: {
    is_editable() {
      let is_edit = true;
      for (let i = 0; i < this.workgroups.length; i++) {
        if (this.workgroups[i]._id == undefined) {
          is_edit = false;
        }
      }
      return is_edit;
    },
    form() {
      const fObj = {};
      for (let i = 0; i < this.workgroups.length; i++) {
        fObj["name_" + i] = this.workgroups[i].name;
      }
      return fObj;
    },
    saveDisabled() {
      let formHasErrors = false || !this.is_valid;
      Object.keys(this.form).forEach((f) => {
        if (!this.form[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    drawerForm() {
      return {
        group_name: this.current_workgroup.name,
        task: this.current_workgroup.task_id,
      };
    },
    drawerSaveDisabled() {
      let formHasErrors = false;
      Object.keys(this.drawerForm).forEach((f) => {
        if (!this.drawerForm[f]) formHasErrors = true;
      });
      return formHasErrors;
    },
    taskForm() {
      const fObj = {
        title: this.current_task.title,
      };
      for (const ind in this.current_task.limits) {
        fObj["from_" + ind] = this.current_task.limits[ind].from;
        fObj["to_" + ind] = this.current_task.limits[ind].to;
        fObj["bonus_" + ind] = this.current_task.limits[ind].bonus;
        fObj["type_" + ind] = this.current_task.limits[ind].type;
      }
      return fObj;
    },
    taskSaveDisabled() {
      let formHasErrors = false || this.current_task.limits.length == 0;

      Object.keys(this.taskForm).forEach((f) => {
        if (!this.taskForm[f]) formHasErrors = true;
      });

      return formHasErrors;
    },
    has_order_information() {
      let has_order_information = false;
      const order_informations = [...new Set(this.order_informations)];

      if (order_informations.length != this.order_informations.length) {
        has_order_information = true;
      }
      return has_order_information;
    },
    has_device_information() {
      let has_device_information = false;
      const device_informations = [...new Set(this.device_informations)];

      if (device_informations.length != this.device_informations.length) {
        has_device_information = true;
      }
      return has_device_information;
    },
    has_additional_information() {
      let has_additional_information = false;
      const additional_informations = [...new Set(this.additional_informations)];

      if (additional_informations.length != this.additional_informations.length) {
        has_additional_information = true;
      }
      return has_additional_information;
    },
    workgroups_without_current() {
      const workgroups_without_current = [];
      for(const w of this.workgroups) {
        if(this.current_workgroup && w._id != this.current_workgroup._id) {
          workgroups_without_current.push(w)  
        }
      }
      return workgroups_without_current
    }
  },
  mixins: [Workgroup, WorkgroupInfo],
  watch: {
    drawer() {
      this.create_task = false;
      this.getTasks();
    }
  },
  methods: {
    warehauseChanged() {
      this.updateWorkgroup(true);
    },
    removeLimit(index) {
      this.current_task.limits.splice(index, 1);
    },
    addOrderInformation() {
      this.order_informations.push({
        workgroup: []
      });
    },
    removeOrderInformation(index) {
      this.order_informations.splice(index, 1);
    },
    cancelOrderInformation() {
      this.edit_order_information = false;
      this.getOrderInformation();
    },
    async getOrderInformation() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_order_information_get_own", {
          params: {
            workgroup_id: this.current_workgroup._id,
          },
        })
      );
      this.order_informations = result;
    },
    async getAdditionalInformation() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_additional_information_get_own", {
          params: {
            workgroup_id: this.current_workgroup._id,
          },
        })
      );
      this.additional_informations = result;
    },
    async saveOrderInformation() {
      this.saving_order_information = true;
      this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_order_information_create", {
          params: {
            workgroup_id: this.current_workgroup._id,
            info_list: this.order_informations,
          },
        })
      );
      this.getOrderInformation();
      this.saving_order_information = false;
      this.edit_order_information = false;
    },
    addDeviceInformation() {
      this.device_informations.push({
        workgroup: []
      });
    },
    addAdditionalInformation() {
      this.additional_informations.push({});
    },
    removeDeviceInformation(index) {
      this.device_informations.splice(index, 1);
    },
    removeAdditionalInformation(index) {
      this.additional_informations.splice(index, 1);
    },
    cancelDeviceInformation() {
      this.edit_device_information = false;
      this.getDeviceInformation();
    },
    cancelAdditionalInformation() {
      this.edit_additional_information = false;
      this.getAdditionalInformation();
    },
    async getDeviceInformation() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_device_information_get_own", {
          params: {
            workgroup_id: this.current_workgroup._id,
          },
        })
      );
      this.device_informations = result;
    },
    async saveDeviceInformation() {
      this.saving_device_information = true;
      this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_device_information_create", {
          params: {
            workgroup_id: this.current_workgroup._id,
            info_list: this.device_informations,
          },
        })
      );
      this.getDeviceInformation();
      this.saving_device_information = false;
      this.edit_device_information = false;
    },
    async saveAdditionalInformation() {
      this.saving_additional_information = true;
      this.$communicator.then(
        this,
        await this.$communicator("workgroup_order_additional_information_create", {
          params: {
            workgroup_id: this.current_workgroup._id,
            info_list: this.additional_informations,
          },
        })
      );
      this.getAdditionalInformation();
      this.saving_additional_information = false;
      this.edit_additional_information = false;
    },
    async cancelClicked() {
      this.loading_workgroup = true;
      await this.get_workgroup();
      this.loading_workgroup = false;
      this.disabled = true;
    },
    remove_ticket(index) {
      this.workgroups.splice(index, 1);
    },
    getCurrentWorkgroup(item) {
      this.current_workgroup = this.$copy(item);
      this.order_informations = this.current_workgroup.order_info;
      this.device_informations = this.current_workgroup.device_info;
      this.drawer = true;
      this.getOrderInformation();
      this.getDeviceInformation();
      this.getAdditionalInformation();
    },
    async saveClicked() {
      this.loading_workgroup = true;
      await this.update_workgroup();
      this.loading_workgroup = false;
      this.disabled = true;
      this.cancelClicked();
    },
    async updateWorkgroup(close_drawer = false) {
      const res = this.$communicator.then(
        this,
        await this.$communicator("update_workgroup_by_id", {
          arguments: [this.current_workgroup._id],
          params: this.current_workgroup,
        })
      );
      if (res) {
        if(close_drawer != true) {
          this.drawer = false;
        }
        await this.get_workgroup();
      }
    },
    async getTasks() {
      const res = this.$communicator.then(
        this,
        await this.$communicator("get_task_list")
      );
      if (res && res.tasks) {
        this.all_tasks = res.tasks;
      }
    },
    async createTask() {
      const res = this.$communicator.then(
        this,
        await this.$communicator("create_task", {
          params: this.current_task,
        })
      );
      if (res) {
        this.getTasks();
        this.current_task = {
          title: null,
          type: "meal",
          unit_name: "kg",
          limits: [
            {
              from: "0",
              to: 10,
              bonus: "0",
              type: "a",
            },
          ],
        };
        this.create_task = false;
      }
    },
  },
};
</script>

<style scoped>
.rotate90 {
  transform: rotate(90deg);
}
</style>
